'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('clinic.schedule', {
    url: 'schedule/',
    templateUrl: '/views/partials/clinic/schedule.html',
    controller: 'ClinicScheduleCtrl',
    resolve: {
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Providers - ' + clinic.name + ' - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('ClinicScheduleCtrl', function(
  $stateParams,
  ClinicConfig,
  clinic,
  CurrentUser,
  OCModalUtil,
  IframeService,
) {
  IframeService.addResizeHandler({
    getElement: () => document.getElementById('provider-container'),
  });

  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.PROVIDER_AVAILABILITY,
    pageName: clinic.name,
    content: {
      view: 'practice',
      is_real_practice: String(!CurrentUser.isImpersonated()),
    },
    practiceId: clinic.id,
    userId: CurrentUser.getUser().id,
  });

  const providerUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/clinic/${$stateParams.id}/providers`;
  angular.element('#js-provider-iframe')[0].src = encodeURI(providerUrl);

  const user = CurrentUser.getUser();
  if (_.get(user, 'metadata.publicClinicOnboarding') === true && [null, undefined].includes(_.get(user, 'metadata.publicClinicOnboardingFinished'))) {
    OCModalUtil.showModal('clinicTutorial');
  }
});
